// components/Education.js
import React from 'react';

const Education = () => {
  const education = [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "Technical University of Mombasa",
      location: "Mombasa, Kenya",
      period: "September 2021 – April 2025",
      description: "Designed, developed, implemented and maintained modern software for use in real-life applications.",
      achievements: [
        "Volunteered for IOME001 Mombasa in partnership with TuDelft University in the Netherlands. Aided in designing an electric microscope that uses Raspberry Pi and Arduinos.",
        "Completed final year project with real-world application and documentation.",
        "Part of the Google Developers Community/Club at the Technical University of Mombasa"
      ]
    }
  ];

  return (
    <section id="education" className="section bg-[#f4f3ee] dark:bg-black">
      <div className="container mx-auto px-6">
        <h2 className="section-title">
          <span className="brand-accent">Education</span>
        </h2>
        
        <div className="space-y-8">
          {education.map((edu, index) => (
            <div key={index} className="card brand-card-accent brand-soft-panel">
              <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-4">
                <div>
                  <h3 className="mb-2 text-3xl font-normal leading-none tracking-[-0.05em] text-gray-950 dark:text-white">{edu.degree}</h3>
                  <p className="brand-accent text-lg font-semibold">{edu.institution}</p>
                  <p className="text-sm uppercase tracking-[0.14em] text-gray-600 dark:text-gray-400">{edu.location}</p>
                </div>
                <div className="brand-chip mt-4 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] md:mt-0">
                  {edu.period}
                </div>
              </div>
              
              <p className="mb-4 leading-snug tracking-[-0.02em]">{edu.description}</p>
              
              {edu.achievements && edu.achievements.length > 0 && (
                <div>
                  <h4 className="mb-2 text-sm font-semibold uppercase tracking-[0.12em]">Key Achievements:</h4>
                  <ul className="list-disc list-inside space-y-2 pl-5">
                    {edu.achievements.map((achievement, i) => (
                      <li key={i} className="text-gray-600 dark:text-gray-400">{achievement}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
